import Breadcrumb from "Components/Common/Breadcrumb";
import React from "react";
import { Container } from "reactstrap";

function SecurityView() {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Security" breadcrumbItem="Security" />
          <h4>Security</h4>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default SecurityView;
